export const ANALYTIC_LIST_MODE = 'list';
export const ANALYTIC_INDEPTH_MODE = 'indepth';

export const FILTER_PICKER_MODE = 'picker';
export const FILTER_PICKER_RANGE_MODE = 'picker_range';
